import React from "react";
import { Link } from "react-router-dom";
import logo from "../../assets/image/factweb_auth_logo.svg";
import "../../assets/css/container/login/AuthPages.css";

export default function AuthLayout({ children }: { children: React.ReactNode }) {
  return <main className="auth-page">
    <Link to="/" className="auth-brand" aria-label="FactWeb 홈"><img src={logo} alt="FactWeb" /></Link>
    <section className="auth-card">{children}</section>
    <footer className="auth-footer"><Link to="/policy/terms">이용약관</Link><Link to="/policy/privacy">개인정보처리방침</Link><span>© FactWeb</span></footer>
  </main>;
}
